// import ClassIcon from "@mui/icons-material/Class";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ChecklistIcon from "@mui/icons-material/Checklist";
export const mainNavbarItems = [
  // {
  //   id: 0,
  //   icon: <ClassIcon />,
  //   label: "View Classes",
  //   route: "/admin/view-class",
  // },
  {
    id: 1,
    icon: <AddCircleOutlineIcon />,
    label: "Add New Class",
    route: "/admin/add-new-class",
  },
  {
    id: 2,
    icon: <BorderColorIcon />,
    label: "Analytics",
    route: "/admin/analytics",
  },
  {
    id: 3,
    icon: <ChecklistIcon />,
    label: "Whitelist",
    route: "/admin/whitelist",
  },
  {
    id: 4,
    icon: <ChecklistIcon />,
    label: "Feature Flags",
    route: "/admin/feature-flags",
  },
];
